const nodes = (data, slideindex, parent, level) => {

  const lastslide = window.API.ispringdata.ispringslideslastvisited || 0

  const nodelevel = level || 1
  const nodeparent = parent || '0'
  const nodeparentindex = parseInt(nodeparent)

  return data
  .filter(n => n.parent == nodeparent)
  .sort((a, b) => {

    if(a.order < b.order) { return -1 }
    if(a.order > b.order) { return 1 }
    return 0
  })
  .map(n => {

    return `
      <div class="Node Level_${ nodelevel }">
        <div 
          class="
            Slide
            ${ n.slide > lastslide + 1 ? 'Lock' : 'Check' }              
            ${ n.slide == slideindex + 1 ? 'Selected' : '' }              
            ${ n.slide == 0 ? 'Chapter' : '' } 
          "
          data-slide="${ n.slide }"            
          data-clickable="${ n.slide != 0 && n.slide != slideindex + 1 }"            
          data-state="${ n.slide > lastslide + 1 ? 'Lock' : 'Check' }"
        >
          <div class="Title">${ n.title }</div>
          <div class="State ${  n.slide == 0 ? 'Hidden' : '' }">
            ${ 
              n.slide > lastslide + 1 ? 
              '<div class="Lock"></div>' 
              : 
              '<div class="Check"></div>' 
            }</div>
        </div>
        <div class="Nodes">
          ${ nodes(data, slideindex, n.id, nodelevel + 1)}
        </div>
      </div>
    `
  }).join('')
}

export const drawispringsummarytree = (
  $,
  $ispringsummarytree,
  playbackController, 
  data, 
  slideindex
) => {

  $ispringsummarytree.empty()
  $ispringsummarytree.append(nodes(data, slideindex))
  $ispringsummarytree.find('.Slide')
  .on(
    'click',
    function () {

      const $this = $(this)
      const data = $this.data()

      if( 
        data.state == 'Check' 
        && 
        data.clickable
      ) {

        playbackController.gotoSlide(parseInt(data.slide) - 1)
      }
    }
  )
}